import { useEffect, useState } from 'react';
import CustomForm from '../CustomForm/CustomForm';
import sleep from "sleep-promise";

function Form(props) {

    const [formContent, setFormContent] = useState(<></>);

    useEffect(() => {
        setFormContent(
            <></>
        );

        const load = async () => {

            let values = props.values;

            values = {
                ...props.values,
                title: props.values.title || "",
                published: props.values.published || false,
                description: props.values.description || "",
                video: props.values.video || "",
            }

            const form = {
                labelTitle: 'Editar',
                validateOnChange: true,
                showGoBackButton: false,
                containerType: 'dialog',
                fields: props.fields,
                values: values ? values : false,
                customValidators: props.customValidators,
                handleSubmit: (fields, values) => {
                    props.handleSubmit(fields, values, props.currentNode);
                }
            }

            await sleep(1)

            setFormContent(
                <CustomForm form={{ ...form }} />
            );
        };
        load();
    }, []);

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
